export default "__VITE_ASSET__CG1FrpW7__"